var map = {
	"./account.json": 7790,
	"./booking.json": 9218,
	"./checkinout.json": 6258,
	"./choice-settings.json": 1002,
	"./common.json": 1573,
	"./configuration.json": 4695,
	"./contact.json": 2029,
	"./department-management.json": 9063,
	"./employee.json": 9311,
	"./location-list.json": 2095,
	"./location.json": 3720,
	"./management.json": 3060,
	"./menu.json": 6360,
	"./position-management.json": 7424,
	"./privacy-policy.json": 9338,
	"./schedule.json": 4426,
	"./settingMessage.json": 9372,
	"./signin.json": 7729,
	"./staff-management.json": 117,
	"./staff-type-management.json": 2466,
	"./terms-of-service.json": 1238,
	"./timekeeping-reports.json": 1275,
	"./workHours.json": 2261,
	"./workinghour.json": 3276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7158;